import React, { useState, useEffect } from 'react';
import apiClient from '../api/client';

const PLAN_PRICES = { basic: 29, professional: 59, enterprise: 99 };
const PLAN_LABELS = { basic: 'Básico', professional: 'Profesional', enterprise: 'Enterprise' };
const PLAN_STORES = { basic: '1 sede', professional: 'Hasta 5 sedes', enterprise: 'Ilimitado' };

export default function KontrolAdmin() {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all');

  const fetchTenants = async () => {
    try {
      setLoading(true);
      const res = await apiClient.get('/kontrol/tenants');
      setTenants(res.data);
    } catch (err) {
      alert('Error cargando clientes');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchTenants(); }, []);

  const handleActivate = async (id) => {
    await apiClient.patch(`/kontrol/tenants/${id}/activate`);
    fetchTenants();
  };

  const handleSuspend = async (id) => {
    if (!window.confirm('¿Suspender este cliente?')) return;
    await apiClient.patch(`/kontrol/tenants/${id}/suspend`);
    fetchTenants();
  };

  const handleChangePlan = async (id, plan) => {
    await apiClient.patch(`/kontrol/tenants/${id}/plan`, { plan });
    fetchTenants();
  };

  const filtered = tenants.filter(t => {
    const matchSearch = t.company_name.toLowerCase().includes(search.toLowerCase()) ||
                        t.email.toLowerCase().includes(search.toLowerCase());
    const matchFilter = filter === 'all' || 
                        (filter === 'active' && t.is_active) ||
                        (filter === 'inactive' && !t.is_active);
    return matchSearch && matchFilter;
  });

  const totalMRR = tenants.filter(t => t.is_active).reduce((sum, t) => sum + (PLAN_PRICES[t.plan] || 0), 0);
  const activeCount = tenants.filter(t => t.is_active).length;
  const pendingCount = tenants.filter(t => !t.is_active).length;

  return (
    <div style={{padding:'24px', maxWidth:'1200px', margin:'0 auto'}}>
      <div style={{marginBottom:'24px'}}>
        <h1 style={{fontSize:'28px', fontWeight:'800', color:'#1e293b'}}>⚡ Kontrol Admin</h1>
        <p style={{color:'#64748b', marginTop:'4px'}}>Panel maestro de gestión de clientes</p>
      </div>

      {/* Stats */}
      <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(200px, 1fr))', gap:'16px', marginBottom:'24px'}}>
        {[
          { label: 'Clientes Activos', value: activeCount, color: '#10b981', icon: '✅' },
          { label: 'Pendientes', value: pendingCount, color: '#f59e0b', icon: '⏳' },
          { label: 'MRR', value: `$${totalMRR}`, color: '#6366f1', icon: '💰' },
          { label: 'Total Clientes', value: tenants.length, color: '#3b82f6', icon: '🏢' },
        ].map((s, i) => (
          <div key={i} style={{background:'white', borderRadius:'12px', padding:'20px', boxShadow:'0 1px 3px rgba(0,0,0,0.1)', borderLeft:`4px solid ${s.color}`}}>
            <div style={{fontSize:'24px', marginBottom:'8px'}}>{s.icon}</div>
            <div style={{fontSize:'28px', fontWeight:'800', color:s.color}}>{s.value}</div>
            <div style={{fontSize:'13px', color:'#64748b', marginTop:'4px'}}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Filtros */}
      <div style={{background:'white', borderRadius:'12px', padding:'16px', marginBottom:'16px', boxShadow:'0 1px 3px rgba(0,0,0,0.1)', display:'flex', gap:'12px', flexWrap:'wrap', alignItems:'center'}}>
        <input
          type="text"
          placeholder="Buscar cliente..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{flex:1, minWidth:'200px', padding:'8px 12px', border:'1px solid #e2e8f0', borderRadius:'8px', fontSize:'14px'}}
        />
        {['all','active','inactive'].map(f => (
          <button key={f} onClick={() => setFilter(f)}
            style={{padding:'8px 16px', borderRadius:'8px', border:'none', cursor:'pointer', fontSize:'13px', fontWeight:'600',
              background: filter===f ? '#6366f1' : '#f1f5f9', color: filter===f ? 'white' : '#64748b'}}>
            {f === 'all' ? 'Todos' : f === 'active' ? '✅ Activos' : '⏳ Pendientes'}
          </button>
        ))}
        <button onClick={fetchTenants} style={{padding:'8px 16px', borderRadius:'8px', border:'none', cursor:'pointer', background:'#f1f5f9', color:'#64748b', fontSize:'13px'}}>🔄</button>
      </div>

      {/* Tabla */}
      <div style={{background:'white', borderRadius:'12px', boxShadow:'0 1px 3px rgba(0,0,0,0.1)', overflow:'hidden'}}>
        {loading ? (
          <div style={{padding:'48px', textAlign:'center', color:'#94a3b8'}}>Cargando...</div>
        ) : filtered.length === 0 ? (
          <div style={{padding:'48px', textAlign:'center', color:'#94a3b8'}}>No hay clientes</div>
        ) : (
          <table style={{width:'100%', borderCollapse:'collapse'}}>
            <thead>
              <tr style={{background:'#f8fafc', borderBottom:'1px solid #e2e8f0'}}>
                {['Empresa', 'Email', 'Plan', 'Sedes', 'Estado', 'Acciones'].map(h => (
                  <th key={h} style={{padding:'12px 16px', textAlign:'left', fontSize:'12px', fontWeight:'700', color:'#64748b', textTransform:'uppercase'}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((t, i) => (
                <tr key={t.id} style={{borderBottom:'1px solid #f1f5f9', background: i%2===0?'white':'#fafafa'}}>
                  <td style={{padding:'14px 16px'}}>
                    <div style={{fontWeight:'700', color:'#1e293b'}}>{t.company_name}</div>
                    <div style={{fontSize:'11px', color:'#94a3b8', marginTop:'2px'}}>{t.id}</div>
                  </td>
                  <td style={{padding:'14px 16px', fontSize:'13px', color:'#475569'}}>{t.email}</td>
                  <td style={{padding:'14px 16px'}}>
                    <select
                      value={t.plan}
                      onChange={e => handleChangePlan(t.id, e.target.value)}
                      style={{padding:'4px 8px', borderRadius:'6px', border:'1px solid #e2e8f0', fontSize:'12px', cursor:'pointer'}}
                    >
                      {Object.keys(PLAN_LABELS).map(p => (
                        <option key={p} value={p}>{PLAN_LABELS[p]} - ${PLAN_PRICES[p]}/mes</option>
                      ))}
                    </select>
                  </td>
                  <td style={{padding:'14px 16px', fontSize:'13px', color:'#475569'}}>{PLAN_STORES[t.plan]}</td>
                  <td style={{padding:'14px 16px'}}>
                    <span style={{padding:'4px 10px', borderRadius:'20px', fontSize:'12px', fontWeight:'600',
                      background: t.is_active ? '#dcfce7' : '#fef3c7',
                      color: t.is_active ? '#16a34a' : '#d97706'}}>
                      {t.is_active ? '✅ Activo' : '⏳ Pendiente'}
                    </span>
                  </td>
                  <td style={{padding:'14px 16px'}}>
                    <div style={{display:'flex', gap:'8px', flexWrap:'wrap'}}>
                      {!t.is_active ? (
                        <button onClick={() => handleActivate(t.id)}
                          style={{padding:'6px 12px', borderRadius:'6px', border:'none', cursor:'pointer', background:'#10b981', color:'white', fontSize:'12px', fontWeight:'600'}}>
                          Activar
                        </button>
                      ) : (
                        <button onClick={() => handleSuspend(t.id)}
                          style={{padding:'6px 12px', borderRadius:'6px', border:'none', cursor:'pointer', background:'#ef4444', color:'white', fontSize:'12px', fontWeight:'600'}}>
                          Suspender
                        </button>
                      )}
                      {t.port && (
                        <button onClick={() => {
                          const url = `https://${t.id.substring(0,8)}.kontrol.farmavida.site`;
                          navigator.clipboard.writeText(url);
                          alert('URL copiada: ' + url);
                        }}
                          style={{padding:'6px 12px', borderRadius:'6px', border:'none', cursor:'pointer', background:'#6366f1', color:'white', fontSize:'12px', fontWeight:'600'}}>
                          🔗 URL
                        </button>
                      )}
                    </div>
                    {t.port && <div style={{fontSize:'11px', color:'#94a3b8', marginTop:'4px'}}>Puerto: {t.port}</div>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
